import { getSectionHeadingPath } from '@utils/apiFunctions';
import httpClient from '@utils/httpClient';
import { pathTypes } from '@utils/sectionEnums';

export function fetchMenuCategoriesApiCall(blockId) {
  return httpClient.get(`api/menu-blocks/${blockId}/categories`);
}

export function createMenuCategoryApiCall(blockId, title) {
  return httpClient.post(`api/menu-blocks/${blockId}/categories`, { Title: title });
}

export function updateMenuCategoryApiCall(blockId, categoryId, title) {
  return httpClient.put(`api/menu-blocks/${blockId}/categories/${categoryId}`, { Title: title });
}

export function deleteMenuCategoryApiCall(blockId, categoryId) {
  return httpClient.delete(`api/menu-blocks/${blockId}/categories/${categoryId}`);
}

// PDF Files
export function fetchMenuPdfFilesApiCall(blockId) {
  return httpClient.get(`api/menu-blocks/${blockId}/pdf-files`);
}

export function addMenuPdfFileApiCall(blockId, data) {
  return httpClient.post(`api/menu-blocks/${blockId}/pdf-files`, data);
}

export function updateMenuPdfFileApiCall(blockId, pdfFileId, data) {
  return httpClient.put(`api/menu-blocks/${blockId}/pdf-files/${pdfFileId}`, data);
}

export function deleteMenuPdfFileApiCall(blockId, pdfFileId) {
  return httpClient.delete(`api/menu-blocks/${blockId}/pdf-files/${pdfFileId}`);
}

export function sortMenuPdfFilesApiCall(blockId, items) {
  return httpClient.put(`api/menu-blocks/${blockId}/pdf-files/sort`, { Items: items });
}

export function updateMenuApiCall({
  id,
  isPathDesign,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  menuType,
  pdfUrl,
  layout,
  categories,
  items,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.menu, isPathDesign, id), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,
    menuType,
    pdfUrl,
    layout,
    categories,
    items,

    containerDesign,
    itemDesign,
    buttonDesign,

    designView,
    designLayout,
    itemTextAlign,
    itemTitleSize,
    itemLayout,
    itemFields,
    itemColumns,
  });
}
